import { LabelButton } from 'components/buttons/LabelButton/LabelButton';
import FormSidebar from '../FormSidebar';
import GradientText from 'components/GradientText';
import image from 'images/form-sidebar-picture.jpg';

const DefaultFormSidebar = () => (
    <FormSidebar>
        <LabelButton>GET IN TOUCH</LabelButton>
        <div className="pb-24">
            <GradientText size="middle" textColor="white">
                Increase <br />
                <em>yields</em> with us
            </GradientText>
        </div>
        <img src={image} alt="" />
    </FormSidebar>
);

export default DefaultFormSidebar;
